import { Cookies } from 'react-cookie';

export const API_LOG_IN_REQUEST = 'API_LOG_IN_REQUEST';
export const API_LOG_IN_SUCCESS = 'API_LOG_IN_SUCCESS';
export const API_LOG_IN_FAILURE = 'API_LOG_IN_FAILURE';

export const API_LOG_IN_ADMIN_REQUEST = 'API_LOG_IN_ADMIN_REQUEST';
export const API_LOG_IN_ADMIN_SUCCESS = 'API_LOG_IN_ADMIN_SUCCESS';
export const API_LOG_IN_ADMIN_FAILURE = 'API_LOG_IN_ADMIN_FAILURE';

export const API_REGISTRATION_REQUEST = 'API_REGISTRATION_REQUEST';
export const API_REGISTRATION_SUCCESS = 'API_REGISTRATION_SUCCESS';
export const API_REGISTRATION_FAILURE = 'API_REGISTRATION_FAILURE';

export const API_REGISTRATION_PAGE1_REQUEST = 'API_REGISTRATION_PAGE1_REQUEST';
export const API_REGISTRATION_PAGE1_SUCCESS = 'API_REGISTRATION_PAGE1_SUCCESS';
export const API_REGISTRATION_PAGE1_FAILURE = 'API_REGISTRATION_PAGE1_FAILURE';

export const API_REGISTRATION_PAGE2_REQUEST = 'API_REGISTRATION_PAGE2_REQUEST';
export const API_REGISTRATION_PAGE2_SUCCESS = 'API_REGISTRATION_PAGE2_SUCCESS';
export const API_REGISTRATION_PAGE2_FAILURE = 'API_REGISTRATION_PAGE2_FAILURE';

export const API_REGISTRATION_PAGE3_REQUEST = 'API_REGISTRATION_PAGE3_REQUEST';
export const API_REGISTRATION_PAGE3_SUCCESS = 'API_REGISTRATION_PAGE3_SUCCESS';
export const API_REGISTRATION_PAGE3_FAILURE = 'API_REGISTRATION_PAGE3_FAILURE';

export const API_SHORT_REGISTRATION_REQUEST = 'API_SHORT_REGISTRATION_REQUEST';
export const API_SHORT_REGISTRATION_SUCCESS = 'API_SHORT_REGISTRATION_SUCCESS';
export const API_SHORT_REGISTRATION_FAILURE = 'API_SHORT_REGISTRATION_FAILURE';


export const API_AUTH_USER_REQUEST = 'API_AUTH_USER_REQUEST';
export const API_AUTH_USER_SUCCESS = 'API_AUTH_USER_SUCCESS';
export const API_AUTH_USER_FAILURE = 'API_AUTH_USER_FAILURE';

export const API_AUTH_ADMIN_REQUEST = 'API_AUTH_ADMIN_REQUEST';
export const API_AUTH_ADMIN_SUCCESS = 'API_AUTH_ADMIN_SUCCESS';
export const API_AUTH_ADMIN_FAILURE = 'API_AUTH_ADMIN_FAILURE';

export const GET_TOKEN_FROM_COOKIES = 'GET_TOKEN_FROM_COOKIES';
export const API_LOG_OUT_REQUEST = 'API_LOG_OUT_REQUEST';
export const API_LOG_OUT_SUCCESS = 'API_LOG_OUT_SUCCESS';
export const API_LOG_OUT_FAILURE = 'API_LOG_OUT_FAILURE';
export const API_LOG_IN_RESET = 'API_LOG_IN_RESET';

export const SET_ADMIN = 'SET_ADMIN';

export const API_FORGOTTEN_PASSWORD_REQUEST = 'API_FORGOTTEN_PASSWORD_REQUEST';
export const API_FORGOTTEN_PASSWORD_SUCCESS = 'API_FORGOTTEN_PASSWORD_SUCCESS';
export const API_FORGOTTEN_PASSWORD_FAILURE = 'API_FORGOTTEN_PASSWORD_FAILURE';
export const SET_REG_DONE = 'SET_REG_DONE';

export const forgottenPasswordRequest = () => ({
  type: API_FORGOTTEN_PASSWORD_REQUEST,
});

export const forgottenPasswordSuccess = payload => ({
  type: API_FORGOTTEN_PASSWORD_SUCCESS,
  payload,
});

export const setAdmin = payload => ({
  type: SET_ADMIN,
  payload,
});

export const forgottenPasswordFailure = payload => ({
  type: API_FORGOTTEN_PASSWORD_FAILURE,
  payload,
});

export const setRegDone = () => ({
  type: SET_REG_DONE
});

export const loginReset = () => ({
  type: API_LOG_IN_RESET,
});

export const loginRequest = () => ({
  type: API_LOG_IN_REQUEST,
});

export const loginSuccess = payload => ({
  type: API_LOG_IN_SUCCESS,
  payload,
});

export const loginFailure = payload => ({
  type: API_LOG_IN_FAILURE,
  payload,
});

export const loginAdminRequest= payload =>({
  type: API_LOG_IN_ADMIN_REQUEST,
  payload,
});

export const loginAdminSuccess = payload => ({
  type: API_LOG_IN_ADMIN_SUCCESS,
  payload,
});

export const loginAdminFailure = payload => ({
  type: API_LOG_IN_ADMIN_FAILURE,
  payload,
});

export const registrationRequest = () => ({
  type: API_REGISTRATION_REQUEST,
});

export const registrationSuccess = payload => ({
  type: API_REGISTRATION_SUCCESS,
  payload,
});

export const registrationFailure = payload => ({
  type: API_REGISTRATION_FAILURE,
  payload,
});

export const registrationPage1Request = () => ({
  type: API_REGISTRATION_PAGE1_REQUEST,
});

export const registrationPage1Success = payload => ({
  type: API_REGISTRATION_PAGE1_SUCCESS,
  payload,
});

export const registrationPage1Failure = payload => ({
  type: API_REGISTRATION_PAGE1_FAILURE,
  payload,
});

export const registrationPage2Request = () => ({
  type: API_REGISTRATION_PAGE2_REQUEST,
});

export const registrationPage2Success = payload => ({
  type: API_REGISTRATION_PAGE2_SUCCESS,
  payload,
});

export const registrationPage2Failure = payload => ({
  type: API_REGISTRATION_PAGE2_FAILURE,
  payload,
});


export const registrationPage3Request = () => ({
  type: API_REGISTRATION_PAGE3_REQUEST,
});

export const registrationPage3Success = payload => ({
  type: API_REGISTRATION_PAGE3_SUCCESS,
  payload,
});

export const registrationPage3Failure = payload => ({
  type: API_REGISTRATION_PAGE3_FAILURE,
  payload,
});


export const shortRegistrationFailure = payload => ({
  type: API_SHORT_REGISTRATION_FAILURE,
  payload,
});

export const shortRegistrationRequest = () => ({
  type: API_SHORT_REGISTRATION_REQUEST,
});

export const shortRegistrationSuccess = payload => ({
  type: API_SHORT_REGISTRATION_SUCCESS,
  payload,
});



export const authUserRequest = () => ({
  type: API_AUTH_USER_REQUEST,
});

export const authUserSuccess = payload => ({
  type: API_AUTH_USER_SUCCESS,
  payload,
});

export const authUserFailure = payload => ({
  type: API_AUTH_USER_FAILURE,
  payload,
});

export const authAdminRequest = payload => ({
  type: API_AUTH_ADMIN_REQUEST,
  payload
});

export const authAdminSuccess = payload => ({
  type: API_AUTH_ADMIN_SUCCESS,
  payload,
});

export const authAdminFailure = payload => ({
  type: API_AUTH_ADMIN_FAILURE,
  payload,
});

export const getTokenFromCookies = payload => ({
  type: GET_TOKEN_FROM_COOKIES,
  payload,
});

export const logoutUserRequest = payload => ({
  type: API_LOG_OUT_REQUEST,
  payload,
});

export const logoutUserSuccess = payload => ({
  type: API_LOG_OUT_SUCCESS,
  payload,
});

export const logoutUserFailure = payload => ({
  type: API_LOG_OUT_FAILURE,
  payload,
});

const cookies = new Cookies();

const initialState = {
  token: null,
  fetchingForgottenPassword: false,
  responseForgottenPassword: null,
  isLoggedIn: cookies.get('token') !== undefined,
  fetching: false,
  error: null,
  fetchingReg: false,
  fetchedReg: false,
  fetchedPageReg: false,
  fetchingPageReg: false,
  regDone: false,
  fetchedFirstPageReg: false,
  fetchingFirstPageReg: false,
  user: null,
  newUser: null,
  admin:null
};

export function loginReducer(state = initialState, action) {
  
  switch (action.type) {
    case SET_ADMIN:
      return {
        ...state,
        admin: action.payload
      };
    case API_SHORT_REGISTRATION_REQUEST:
      return {
        ...state,
        fetchedFirstPageReg: false,
        fetchingFirstPageReg: true,
      };
    case API_FORGOTTEN_PASSWORD_REQUEST:
      return {
        ...state,
        fetchingForgottenPassword: true,
      };
  case SET_REG_DONE:

        return {
          ...state,
          regDone: true,
        };
    case API_FORGOTTEN_PASSWORD_SUCCESS:
      return {
        ...state,
        fetchingForgottenPassword: false,
        responseForgottenPassword: action.payload,
      };
    case API_LOG_IN_RESET:
      return {
        ...state,
        ...initialState,
      };
    case GET_TOKEN_FROM_COOKIES:
      return {
        ...state,
        token: action.payload,
      };
    case API_LOG_IN_REQUEST:
    case API_LOG_IN_ADMIN_REQUEST:
      
      return {
        ...state,
        newUser: action.payload,
      };
    case API_REGISTRATION_REQUEST:
      return {
        ...state,
        fetchingReg: true,
        fetchedReg:false,
      };
      case API_REGISTRATION_PAGE1_REQUEST:
        return {
          ...state,
          fetchingPageReg: true,
          fetchedPageReg:false,
        };
      case API_REGISTRATION_PAGE2_REQUEST:
          return {
            ...state,
            fetchingPageReg: true,
            fetchedPageReg:false,
          };
      case API_REGISTRATION_PAGE3_REQUEST:
            return {
              ...state,
              fetchingPageReg: true,
              fetchedPageReg:false,
            };
    case API_AUTH_USER_REQUEST:
    case API_AUTH_ADMIN_REQUEST:
      return {
        ...state,
        newUser: action.payload,
      }
    case API_LOG_OUT_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_LOG_IN_SUCCESS:
      
      return {
        ...state,
        isLoggedIn: true,
        user: action.payload,
        token: action.payload.token
      };
    case API_LOG_IN_ADMIN_SUCCESS:
       
        var tmp = state.newUser
        tmp = {...tmp, token:action.payload.token}
        
        return {
          ...state,
          isLoggedIn: true,
          user: tmp,
          token: action.payload.token
        }
    case API_REGISTRATION_SUCCESS:
      // debugger;
      var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
      return {
        ...state,
        fetching: false,
        isLoggedIn: true,
        token,
        fetchingReg: false,
        fetchedReg:true,
        user: { ...state.user, ...user },
        error: null,
      };
      case API_REGISTRATION_PAGE1_SUCCESS:
        // debugger;
        var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
        return {
          ...state,
          token,
          fetchingPageReg: false,
          fetchedPageReg:true,
          user: { ...state.user, ...user },
          error: null,
        };
        case API_REGISTRATION_PAGE2_SUCCESS:
          // debugger;
          var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
          return {
            ...state,
            token,
            fetchingPageReg: false,
            fetchedPageReg:true,
            user: { ...state.user, ...user },
            error: null,
          };
        case API_REGISTRATION_PAGE3_SUCCESS:
            // debugger;
            var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
            return {
              ...state,
              token,
              fetchingPageReg: false,
              fetchedPageReg:true,
              user: { ...state.user, ...user },
              error: null,
            };
    case API_SHORT_REGISTRATION_SUCCESS:
      var { token, ...user } = action.payload; // eslint-disable-line no-case-declarations
      return {
        ...state,
        fetching: false,
        isLoggedIn: true,
        token,
        fetchedFirstPageReg: true,
        fetchingFirstPageReg: false,
        user: { ...state.user, ...user },
        error: null,
      };
    case API_AUTH_USER_SUCCESS:
      
      return {
        ...state,
        user: action.payload,
      };
    case API_AUTH_ADMIN_SUCCESS:
      
        return {
          ...state,
          user: state.newUser,
        };
    case API_LOG_OUT_SUCCESS:
      return {
        ...state,
        fetching: false,
        isLoggedIn: false,
        token: null,
        user: null,
      };
    case API_LOG_IN_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched:true,
        error: action.payload,
      };
      case API_LOG_IN_ADMIN_FAILURE:
        return {
          ...state,
          fetching: false,
          fetched:true,
          error: action.payload,
        };
    case API_REGISTRATION_FAILURE:
      return {
        ...state,
        fetchingReg: false,
        fetchedReg:true,
        error: action.payload,
      };
      case API_REGISTRATION_PAGE1_FAILURE:
        return {
          ...state,
          fetchingPageReg: false,
          fetchedPageReg:true,
          error: action.payload,
        };
        case API_REGISTRATION_PAGE2_FAILURE:
          return {
            ...state,
            fetchingPageReg: false,
            fetchedPageReg:true,
            error: action.payload,
          };

          case API_REGISTRATION_PAGE3_FAILURE:
            return {
              ...state,
              fetchingPageReg: false,
              fetchedPageReg:true,
              error: action.payload,
            };
    

    case API_AUTH_USER_FAILURE:
    case API_AUTH_ADMIN_FAILURE:
    case API_LOG_OUT_FAILURE:
    case API_FORGOTTEN_PASSWORD_FAILURE:
      return {
        ...state,
        fetching: false,
        isLoggedIn: false,
        error: action.payload,
        token: null,
        user: null,
      };
    default:
      return state;
  }
}
